import React from 'react';
import { ModalHeader } from '../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../CommonComponents/OPL/Modal/ModalBody';
import { Modal } from '../../CommonComponents/OPL/Modal/Modal';
import { ModalCloseButton } from '../../CommonComponents/OPL/Modal/ModalCloseButton';
import { Text } from '../../CommonComponents/OPL/Text/Text';
import { formatCurrency } from '../../CommonUtils/formatNumber';

interface Props {
  onClose(): void;
  desiredPurchaseYear: number;
  chartSeries: {
    Current: number;
    Recommended: number;
  };
}

export const HomePurchaseChartModal: React.FC<Props> = ({
  onClose,
  desiredPurchaseYear,
  chartSeries: { Current, Recommended },
}) => {
  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      aria={{
        labelledby: 'home-purchase-chart-modal-heading',
        describedby: 'home-purchase-chart-modal-description',
      }}
    >
      <ModalHeader id="home-purchase-chart-modal-heading">Savings Schedule</ModalHeader>
      <ModalCloseButton onClick={onClose} />
      <ModalBody id="home-purchase-chart-modal-description">
        <Text as="p">
          The bar chart displays your savings schedule for covering your down payment of a new home
          by {desiredPurchaseYear}. It consists of your goal savings of&nbsp;
          {formatCurrency(Recommended)}. It compares that figure with how much you will actually
          save by {desiredPurchaseYear}, which is {formatCurrency(Current)}.
        </Text>
      </ModalBody>
    </Modal>
  );
};
